import React, { FC } from 'react';
import { Button, Popconfirm } from 'antd';
import { useTranslation } from 'react-i18next';

import { RemoveIcon } from '~/img';
import { usePermissions } from '~/hooks';
import { usePaymentDetailsDelete } from '~/hooks/paymentDetails';

interface PaymentDetailsDeleteProps {
  id: string;
  closeParent: () => void;
}

const PaymentDetailsDelete: FC<PaymentDetailsDeleteProps> = (props) => {
  const { id, closeParent } = props;
  const [t] = useTranslation();

  const { mutate, isLoading } = usePaymentDetailsDelete(closeParent);

  const hasAccess = usePermissions('business.paymentDetails.delete');
  if (!hasAccess) return null;
  return (
    <Popconfirm
      title={t('areYouSure')}
      okText={t('yes')}
      cancelText={t('no')}
      onConfirm={() => mutate(id)}
    >
      <Button danger type="text" icon={<RemoveIcon />} loading={isLoading}>
        {t('delete')}
      </Button>
    </Popconfirm>
  );
};

export default PaymentDetailsDelete;
